module.exports = __webpack_public_path__ + "img/svg.6b7fd225.svg";